export class Transcoder {
}
//# sourceMappingURL=Transcoder.js.map